import type { NavigationGroupModel } from '../../../../../../types';

const MAX_DESKTOP_COLUMNS = 5;

export function resolveColumnCount(desktopColumnCount: number | undefined, columns: NavigationGroupModel[][]): number {
    const populatedCount = columns.filter(column => column.length > 0).length;
    const count = desktopColumnCount ?? populatedCount;

    return Math.min(Math.max(count, 1), MAX_DESKTOP_COLUMNS);
}
